var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "ap-workspace-head" }, [
        _c("div", { staticClass: "ap-workspace-label" }, [
          _c("div", { staticClass: "ap-workspace-label-name" }, [
            _vm._v("\n                    Организации\n                ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ap-workspace-label-btn",
              on: {
                click: function($event) {
                  return _vm.addOrganization()
                }
              }
            },
            [_c("SVGPlus")],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ap-workspace-label-btn ap-add-left-margin" },
          [
            _c("label", { staticClass: "ap-search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mask,
                    expression: "mask"
                  }
                ],
                staticClass: "ap-search-input",
                attrs: { type: "text", placeholder: "Найти организацию" },
                domProps: { value: _vm.mask },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.mask = $event.target.value
                  }
                }
              })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "vue-custom-scrollbar",
        { on: { "ps-y-reach-end": _vm.scrollReachEnd } },
        [
          _c("div", { staticClass: "ap-workspace-table-container" }, [
            _c("table", { staticClass: "result-table" }, [
              _c("thead", [
                _c("tr", { staticClass: "head-tr" }, [
                  _c("th", [_vm._v("№")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Название")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Тип")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Телефон")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Описание")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "field-edit" }, [_vm._v("Опции")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.organizations, function(value) {
                  return _c("tr", { staticClass: "body-tr row" }, [
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.id))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.type))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.phone))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.description))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", { staticClass: "edit-button-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "table-svg-button",
                            on: {
                              click: function($event) {
                                return _vm.editOrganization(value)
                              }
                            }
                          },
                          [_c("SVGAdminEditRow")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "table-svg-button",
                            on: {
                              click: function($event) {
                                return _vm.confirm(value)
                              }
                            }
                          },
                          [_c("SVGAdminDeleteRow")],
                          1
                        )
                      ])
                    ])
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _vm.waitingResponseToOrganizationsRequest
              ? _c(
                  "div",
                  { staticClass: "ap-loader-grid" },
                  [
                    _c("SpinnerTwo"),
                    _vm._v(" "),
                    _c("div", { staticClass: "ap-loader-text" }, [
                      _vm._v(
                        "\n                    Идет загрузка организаций ...\n                "
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }